const configuredApiUrl = 'https://api.g8rcase.com/api';
const isPlaceholder = configuredApiUrl.startsWith('API_BASE_URL');

export const environment = {
  production: false,
  apiUrl: isPlaceholder ? '/api' : configuredApiUrl,
};
